export default {
  pages: (state) => state.pages,
  seoPaginated: (state) => state.seoPaginated,
  selectedPage: (state) => state.selectedPage,
  localizedPages: (state) => state.localizedPages,
  selectLocalizedPage: (state) => state.selectLocalizedPage,
  pageCategory: (state) => state.pageCategory,
  selectedPageCategory: (state) => state.selectedPageCategory,
};
